
import React from "react";

const ADDR_0 = [
  "Regular Mail",
  "TD Ameritrade Institutional",
  "P.O. Box 650567",
  "Dallas, TX 75265-0567",
];

const ADDR_1 = [
  "or you can use:",
];

const ADDR_2 = [
  "Overnight Mail",
  "TD Ameritrade Institutional",
  "7801 Mesquite Bend Drive",
  "Suite 112",
  "Irving, TX 75063-6043",
]

const TDAMailInstructions = (props) => {

  const account_number = props.account_number;

  const div_style = {
    padding: "0.5rem 0",
  }
  const bold_style = {
    fontWeight: "bold",
  }
  return (
    <div>
      <div style={{paddingLeft: "4rem"}}>
        <div style={div_style}>
          <p>Make the check payable to <span style={bold_style}>TD Ameritrade Clearing</span>.</p>
        </div>
        <div style={div_style}>
          <p>In the memo section, include your account number <span style={bold_style}>{account_number}</span>.</p>
        </div>
        <div style={div_style}>
          <p>For <span style={bold_style}>IRA</span> accounts, please include the <span style={bold_style}>contribution year</span>.</p>
        </div>
      </div>
      <div style={div_style}>
        <p>Mail the check:</p>
      </div>
      <TDAAddresses/>
    </div>
  )
}

const TDAAddresses = () => {

  const div_flex = {
    padding: "0.5rem 0",
    display: "flex",
  }

  const mk_addr_item = lines => {

    const line_func = (line, index) => {
      const style = index === 0
        ? { fontWeight: "bold" }
        : { fontWeight: "normal" };
      return (
        <div style={style} key={index}>
          { line }
        </div>
      )
    };

    return (
      <div style={{width: "15rem"}}>
        { lines.map(line_func) }
      </div>
    )
  };

  return (
    <div style={div_flex}>
      { mk_addr_item(ADDR_0) }
      { mk_addr_item(ADDR_1) }
      { mk_addr_item(ADDR_2) }
    </div>
  );
}

export { TDAAddresses, TDAMailInstructions };
